import LikeButton from "./LikeButton";

export default LikeButton;
